function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1acf380e\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Header.vue")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1acf380e\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Header.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1acf380e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/components/header/Header.vue
// module id = ddb233dcf5d6641015d6
// module chunks = 89